import React from 'react'
import OperatorPhotosScreen from './OperatorPhotos'

const DronePhotosScreen: React.FC = () => {
  return <OperatorPhotosScreen category="drone" />
}

export default DronePhotosScreen
